import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from 'src/app/core/common/ui';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { errorRoutes } from './error.routes';

@NgModule({
  imports: [RouterModule.forChild(errorRoutes), UiModule],
  declarations: [NotFoundComponent],
  exports: [],
})
export class ErrorModule {}
